import { DataDictionaryResponse } from './getDataDictionary';
import { DataSecurityApplication } from '../../@types/data-security/DataSecurityApplication';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams } from '@sonar-software/sonar-ts-types';

export type GetSharedDataDictionaryRequest = KeyPaginationQueryParams & DynamicQueryParams & {
	sharedKey: string;
	filterByName?: string
};

export type GetSharedDataDictionaryResponse = DataDictionaryResponse & {
	applications: Array<DataSecurityApplication>;
	organizationName: string;
	owners: Array<{ id: number; name: string }>;
	stakeholders: Array<{ id: number; name: string; userId: number }>;
	tags: Array<{ color: string; id: number; name: string }>;
	viewName: string;
};

export const getSharedDataDictionary = createGetEndpoint<
	GetSharedDataDictionaryRequest,
	GetSharedDataDictionaryResponse
>(({ sharedKey, ...rest }) => `/api/v3/data-dictionary/views/${sharedKey}/embedded?${getQueryString(rest)}`);
